// removed by extract-text-webpack-plugin
module.exports = {"questionPackageWrapper":"_5JUqBAbKbr8ShxRLdawwE","countWrapper":"IIYarZU6ihUifwWD4Z6sE","count":"BgoX0sbf4F1b027nigPf","subtitle":"_2JRE0ME6x13BDuDsUXZsSS","priceBlock":"_3Zq7uhsEp7clxRvLNVMOg_","oldPrice":"_2YqS5mwhRy1DEsfFq8bK8y","price":"_1zXKcqXLFiYfYDgQgbv1oF","priceTitle":"_2liYZwx6TN_SuQMX9HN3ut","actionButton":"_176XZtGARt3rJzMGRbEm4Q","questionPackageMobileWrapper":"_6LqpmyVTGQbf7GpeiJvtB","topBlock":"ROlXWDNymnJ83aJyh896R","circle":"_35GiORXopIQj0oZ7enWyIA","circleBlue":"_18IJEeaR7C0DqUTVwNx-Pb","buttonWrapper":"_1jsI6IpA80eKH61veyA9tz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorQuestionPackage/RealtorQuestionPackage.scss
// module id = 784
// module chunks = 0